/* eslint-disable @typescript-eslint/no-explicit-any */
import Core from '../core';
import { AxiosError } from 'axios';

async function clockIn(
  employeeId: number,
  company_id: number,
  note: string,
  location: string,
) {
  const api = Core.getInstance().api();
  const data = await api.post(
    `/clock_in?emp_id=${employeeId}&company_id=${company_id}&note=${note}&location=${location}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function check_in(
  employeeId: number,
  company_id: number,
  checkin_time: any,
  note: string,
  location_id: string,
  lat: any,
  lng: any,
) {
  const api = Core.getInstance().api();
  const data = await api.post(
    `/v2/attendance/checkin?emp_id=${employeeId}&company_id=${company_id}&note=${note}&location_id=${location_id}&lat=${lat}&lng=${lng}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function can_checkin(employeeId: number) {
  const api = Core.getInstance().api();
  const data = await api.post(`/v1/can_checkin?emp_id=${employeeId}`);

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getEmployeeLocationList(employeeId: number, companyId: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/locations/foremployee?emp_id=${employeeId}&company_id=${companyId}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

export const clockInService = {
  clockIn,
  check_in,
  can_checkin,
  getEmployeeLocationList,
};
